<img [src]="srcPath" class="{{ className }}" />
